import { useRouter } from 'next/router';
import { useMemo } from 'react';

export const useFilterQuery = () => {
  const router = useRouter();

  const params = new URLSearchParams(router?.asPath?.split('?')[1]);

  return useMemo(() => (
    params?.get('filter') || ''
  ), [params]);
};
